import { IFile } from '~/interfaces/shared';
import { validateFile } from './validators.helper';

export const filterOutIncorrectFiles = (
  files: IFile[],
  allowedFileFormats: string[],
  maxSize: number,
  maxFiles: number
) => {
  const validFiles = files
    .filter((file) => validateFile(file, allowedFileFormats, maxSize).isValid)
    .filter(removeDuplicates);

  return validFiles.slice(0, maxFiles);
};

const removeDuplicates = (item: IFile, i: number, arr: Array<IFile>) => {
  return i === arr.findIndex((t) => t.name === item.name);
};

export const getFileExtension = (filename: string) => filename.split('.').pop();
